export enum PlanEnum {
  FREE = 'free',
  PAY_AS_YOU_GO = 'pay-as-you-go',
}
